import image1 from '/public/img/templates/tem1.jpg'
import image2 from '/public/img/templates/tem2.jpg'
import image3 from '/public/img/templates/tem3.jpg'

export let templates_data = [
  {
    id: 1,
    url: '#',
    title: 'Product marketplace',
    image: image1,
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum molestiae sint explicabo veritatis odio corporis commodi mollitia dolore harum aut.',
    full_details:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit eaque quas impedit nam facilis nobis a, dolorem maiores tenetur itaque aperiam doloribus dolore sequi  m porro iure debitis nihil quis amet pariatur? Harum explicabo natus ex quisquam ipsam  odi dolor expedita! Quo quia eius animi itaque totam dolorum? Et ea in veritatis provident animi natus accusamus assumenda praesentium officiis officia error magnam placeat, neque sint veniam? Sint maxime tenetur, non architecto reiciendis commodi reprehenderit debitis dolorum tempore corporis exercitationem a voluptates deleniti sunt vel illo, quia consectetur. Animi voluptate debitis neque quas quos eveniet tempora unde eos eius veniam! In cupiditate praesentium aut, perspiciatis aperiam dolore dolores eum nisi quibusdam a s iusto illo deserunt sit dolor consequatur, illum eaque rem corrupti. Aut, labore?',
    type: 'PRODUCT',
    subtype: 'B2C/D2C',
  },
  {
    id: 2,
    url: '#',
    title: ' Partner directory ',
    image: image2,
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum molestiae sint explicabo veritatis odio corporis commodi mollitia dolore harum aut.',
    type: 'SAAS',
    subtype: 'B2C/D2C',
  },
  {
    id: 3,
    url: '#',
    title: 'Event marketplace',
    image: image3,
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum molestiae sint explicabo veritatis odio corporis commodi mollitia dolore harum aut.',
    type: 'EVENT',
    subtype: 'B2C/D2C',
  },
]
